import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Logo } from "@/components/site/Logo";
import { Input } from "@/components/ui/input";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/login", { email, password });
            navigate("/admin");
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-[#120E09] px-6" data-testid="admin-login-page">
            <form onSubmit={submit} className="w-full max-w-sm rounded border border-[#2E2517] bg-[#1B150E] p-8">
                <div className="mb-8 flex flex-col items-center gap-4">
                    <Logo size={88} />
                    <h1 className="font-display text-xl font-extrabold uppercase tracking-tight text-[#EDE6DA]">Admin-Login</h1>
                </div>
                <label htmlFor="login-email" className="mb-2 block text-xs font-semibold uppercase tracking-[0.2em] text-[#9C917D]">E-Mail</label>
                <Input id="login-email" data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mb-5 border-[#2E2517] bg-[#120E09] text-[#EDE6DA]" />
                <label htmlFor="login-password" className="mb-2 block text-xs font-semibold uppercase tracking-[0.2em] text-[#9C917D]">Passwort</label>
                <Input id="login-password" data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mb-8 border-[#2E2517] bg-[#120E09] text-[#EDE6DA]" />
                <button
                    data-testid="login-submit-button"
                    type="submit"
                    disabled={loading}
                    className="w-full rounded-full bg-[#C88A45] py-3 text-sm font-bold uppercase tracking-wide text-[#120E09] transition-[background-color,opacity] duration-200 hover:bg-[#DBA057] disabled:opacity-50"
                >
                    {loading ? "Anmelden …" : "Anmelden"}
                </button>
                <Link to="/" data-testid="login-back-link" className="mt-6 block text-center text-xs text-[#9C917D] transition-colors duration-200 hover:text-[#C88A45]">
                    Zurück zur Website
                </Link>
            </form>
        </div>
    );
}
